import { render, staticRenderFns } from "./ExpandingFaqItem.vue?vue&type=template&id=65f40e0d&scoped=true&"
import script from "./ExpandingFaqItem.vue?vue&type=script&lang=js&"
export * from "./ExpandingFaqItem.vue?vue&type=script&lang=js&"
import style0 from "./ExpandingFaqItem.vue?vue&type=style&index=0&id=65f40e0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f40e0d",
  null
  
)

export default component.exports